import "./App.css";
import { useEffect } from "react";
import Lottie from "lottie-react";
import Router from "./router/routes";
import SpinnerInitializer from "./components/common/SpinnerInitializer";
import { startGlobalTimer } from "./utils/timerService";
import { useLaunch } from "../auth/useAuth";
import dkLoader from "../assets/dk-loader.json";

const App = () => {
  useEffect(() => {
    startGlobalTimer();
  }, []);

  const { isReady, isLoading, error } = useLaunch();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex flex-col relative overflow-x-hidden">
        <div className="fixed inset-0 z-0 pointer-events-none bg-[#121212]" />
        <div className="relative z-10 flex flex-col min-h-screen">
          <main className="flex-grow flex justify-center items-center">
            <div className="relative w-full max-w-[375px] flex items-center justify-center">
              <Lottie
                animationData={dkLoader}
                loop
                autoplay
                className="w-24 h-24"
              />
            </div>
          </main>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-screen w-full bg-[#121212] flex items-center justify-center">
        <div className="text-white text-center max-w-sm px-6">
          <p className="text-xl font-semibold mb-2">Unable to launch game</p>
          <p className="text-sm text-white/60 mb-4">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <SpinnerInitializer />
      <Router isLoggedIn={isReady} />
    </>
  );
};

export default App;
